/* ============================================================
   BitX · Favoritos (motor)
   ------------------------------------------------------------
   Guarda favoritos en el navegador (localStorage), marca los
   corazones, mantiene el contador del header y avisa a las
   plataformas de marketing (Klaviyo/Meta/Google) cuando alguien
   guarda o quita un producto.

   Sin apps, sin login obligatorio. Mismo estilo que 'recently viewed'.
   Expone window.BitxFav para que el resto del tema lo use.
   ============================================================ */
(function () {
  'use strict';

  var KEY = 'bitx_fav_v1'; // clave en el navegador (versionada, por si cambia el formato)

  /* ---------- Leer / escribir la lista ---------- */
  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }

  /* ---------- Consultas ---------- */
  function has(id) {
    id = String(id);
    return read().some(function (x) { return x && String(x.id) === id; });
  }
  function count() { return read().length; }
  function all() { return read(); }

  /* ---------- Guardar / quitar ---------- */
  // product = { id, handle, title, url, img, money, ... } (lo mismo que usa recently viewed)
  function add(product) {
    if (!product || product.id == null) return read();
    var list = read();
    if (list.some(function (x) { return String(x.id) === String(product.id); })) return list;
    product.ts = Date.now();
    list.unshift(product);           // el más nuevo primero
    write(list);
    dispatch('add', product);        // avisa: se guardó
    return list;
  }
  function remove(id) {
    id = String(id);
    var list = read();
    var removed = list.filter(function (x) { return String(x.id) === id; })[0] || { id: id };
    list = list.filter(function (x) { return String(x.id) !== id; });
    write(list);
    dispatch('remove', removed);     // avisa: se quitó
    return list;
  }
  // Botón corazón: si está, lo quita; si no, lo guarda. Devuelve true si quedó guardado.
  function toggle(product) {
    if (has(product.id)) { remove(product.id); return false; }
    add(product); return true;
  }

  /* ---------- Avisos (eventos) ---------- */
  function dispatch(action, product) {
    // 1) Evento interno del tema: los corazones y el contador se actualizan solos.
    document.dispatchEvent(new CustomEvent('bitx:fav:changed', {
      detail: { action: action, product: product, count: count() }
    }));
    // 2) Evento para marketing (lo captará el pixel personalizado de Shopify en la Parte 6).
    //    Solo cuando se AGREGA, que es lo que interesa para remarketing.
    if (action === 'add' && window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
      try {
        Shopify.analytics.publish('bitx_wishlist_added', {
          id: product.id,
          handle: product.handle,
          name: product.title,
          price: product.price_amount,   // número plano para las plataformas
          currency: window.Shopify && Shopify.currency ? Shopify.currency.active : 'CLP',
          url: product.url
        });
      } catch (e) {}
    }
  }

  /* ---------- Pintar el estado de los botones y el contador ---------- */
  function paintButtons(root) {
    root = root || document;
    var btns = root.querySelectorAll('.bitx-fav-btn[data-fav-id]');
    for (var i = 0; i < btns.length; i++) {
      var on = has(btns[i].getAttribute('data-fav-id'));
      btns[i].classList.toggle('is-active', on);
      btns[i].setAttribute('aria-pressed', on ? 'true' : 'false');
      var lbl = on ? (btns[i].getAttribute('data-label-on') || 'Guardado en favoritos')
                   : (btns[i].getAttribute('data-label-off') || 'Guardar en favoritos');
      btns[i].setAttribute('aria-label', lbl);
      var t = btns[i].querySelector('.bitx-fav-btn__text');
      if (t) t.textContent = lbl;
    }
  }
    function paintHeart() {
    var on = count() > 0;
    var hearts = document.querySelectorAll('.bitx-fav-header');
    for (var i = 0; i < hearts.length; i++) {
      hearts[i].classList.toggle('has-favs', on);
    }
  }
  function paintCount() {
    var n = count();
    var nodes = document.querySelectorAll('[data-bitx-fav-count]');
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].textContent = n;
      nodes[i].hidden = (n === 0);            // oculta el "0"
      nodes[i].classList.toggle('is-empty', n === 0);
    }
  }
    function paintAll(root) { paintButtons(root); paintCount(); paintHeart(); }

  /* ---------- Clic en cualquier corazón (delegación: sirve para tarjetas cargadas después) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.bitx-fav-btn[data-fav-id]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation(); // evita que un corazón dentro de un enlace de tarjeta navegue

    var product = {
      id: btn.getAttribute('data-fav-id'),
      handle: btn.getAttribute('data-fav-handle') || '',
      title: btn.getAttribute('data-fav-title') || '',
      url: btn.getAttribute('data-fav-url') || '',
      img: btn.getAttribute('data-fav-img') || '',
      money: btn.getAttribute('data-fav-money') || '',
      price_amount: parseFloat(btn.getAttribute('data-fav-price') || '0') || 0
    };
    var nowActive = toggle(product);

    // micro-animación de "pop"
    btn.classList.remove('bitx-fav--pop');
    void btn.offsetWidth;
    btn.classList.add('bitx-fav--pop');
  });

  /* ---------- Cuando algo cambia, repintar corazones y contador ---------- */
  document.addEventListener('bitx:fav:changed', function () { paintAll(); });

  // Sincroniza entre pestañas abiertas del mismo navegador
  window.addEventListener('storage', function (e) { if (e.key === KEY) paintAll(); });

  /* ---------- API pública para el resto del tema ---------- */
  window.BitxFav = {
    read: read, all: all, has: has, count: count,
    add: add, remove: remove, toggle: toggle,
    paintButtons: paintButtons, paintCount: paintCount, paintAll: paintAll,
    KEY: KEY
  };

  /* ---------- Arranque ---------- */
  function init() { paintAll(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
